import * as z from 'zod';

import {id} from '../global/globalModels';

export const baseTeam = z.object({
    id: id,
    name: z.string(),
    departmentId: id,
    userCount: z.number(),
});

export type BaseTeam = z.infer<typeof baseTeam>;
